import RSuiteDatePicker from "../components/RsuiteDatePicker";

export const convert_dd_mm_yy_to_Date = (date_string) => {
  // console.log(date_string);
  const [dd, mm, yy] = date_string.split("/")?.map((d) => parseInt(d));
  return new Date(yy, mm - 1, dd);
};
export const sample_types = [
  { label: "SFG(with micro)", value: "SFG(with micro)" },
  { label: "SFG(without micro)", value: "SFG(without micro)" },
  { label: "FP(with micro)", value: "FP(without micro)" },
  {
    label: "CB(urgent)",
    value: "CB(urgent)",
  },
  {
    label: "CB",
    value: "CB",
  },
  {
    label: "CB(additional)",
    value: "CB(additional)",
  },
];

export const date_time_string_to_date = (date_time_string) => {
  // console.log({ date_time_string, d: new Date(date_time_string) });
  return new Date(date_time_string);
};

export const date_column_properties = {
  type: "date",
  valueGetter: ({ value }) => {
    if (typeof value === "object") return value;
    return value && convert_dd_mm_yy_to_Date(value);
  },
};
export const prodPlannerGridColumns = {
  material: {
    field: "material",
    headerName: "MATERIAL",
    visible: true,
    editable: false,
    width: 150,
  },
  material_description: {
    field: "material_description",
    headerName: "MATERIAL DESCRIPTION",
    visible: true,
    editable: false,
    width: 300,
  },
  batch_no: {
    field: "batch_no",
    headerName: "BATCH",
    visible: true,
    editable: false,
    width: 100,
  },
  order: {
    field: "order",
    headerName: "ORDER",
    isEditable: false,
    flex: 1,
  },
  unit: {
    field: "unit",
    headerName: "UNIT",
    isEditable: false,
    width: 100,
  },
  "stor._loc.": {
    field: "stor._loc.",
    headerName: "STORAGE LOCATION",
    width: 200,
    isEditable: false,
  },
  expected_delivery_date_by_production: {
    field: "expected_delivery_date_by_production",
    headerName: "EXPECTED DELIVERY DATE BY PRODUCTION",
    visible: true,
    editable: false,
    width: 300,
    type: "dateTime",
    ...date_column_properties,
    renderCell: RSuiteDatePicker,
  },
};
